import { BrowserRouter, Route, Routes } from "react-router-dom";
import ErrorPage from "./pages/ErrorPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import RegistroPage from "./pages/RegistroPage";
import RouteScrollToTop from "./helper/RouteScrollToTop"; 
import HomePageNine from "./pages/HomePageNine"; 
import Comprobantes from "./pages/views/Comprobantes";
import Usuarios from "./pages/views/Usuarios";
import Autorizaciones from "./pages/views/Autorizaciones";
import Descargas from "./pages/views/Descargas";
import Notificaciones from "./pages/views/Notificaciones";
import Sincronizacion from "./pages/views/Sincronizacion";

import ComprobantesAdmi from "./pages/views/ComprobantesAdmin";
import ComprobantesDelegado from "./pages/views/ComprobantesDelegado";
import Theme from "./pages/views/Theme";
import ConsultasAdmin from "./pages/views/ConsultasAdmin";
import Consultas from "./pages/views/Consultas";

function App() {

  

  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <Routes>
        {/* <Route exact path='/' element={<HomePageOne />} /> */}
        <Route exact path='/' element={<SignInPage />} />
        <Route exact path='/theme' element={<Theme />} />
        <Route exact path='/comprobantesAdmin' element={<ComprobantesAdmi />} />
        <Route exact path='/comprobantesDelegado' element={<ComprobantesDelegado />} />
        <Route exact path='/comprobantes' element={<Comprobantes />} />
        <Route exact path='/usuarios' element={<Usuarios/>} />
        <Route exact path='/sincronizacion' element={<Sincronizacion/>} />
        <Route exact path='/autorizaciones' element={<Autorizaciones/>} />
        <Route exact path='/descargas' element={<Descargas/>} />
        <Route exact path='/notificaciones' element={<Notificaciones/>} />
        <Route exact path='/index-9' element={<HomePageNine />} />
        <Route exact path='/sign-up' element={<SignUpPage />} />
        <Route exact path='/registro' element={<RegistroPage />} />
        <Route exact path='/forgot-password' element={<ForgotPasswordPage />} />
        <Route exact path='/admin/consultas' element={<ConsultasAdmin />} />
        <Route exact path='/consultas' element={<Consultas />} />
        <Route exact path='*' element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
